// Sort out the type of facets in parent component, SearchResultList
export const FACET_GROUP_INFO = {
  distinctTitle: {
    title: 'Not sure what to search for?',
    description: 'Try one of the most in demand jobs in your location.',
    isMultiSelect: false,
    searchQueryKey: undefined, // This facet does not have a searchQuery key
  },
  salaryMin: {
    title: 'What salary are you looking for?',
    description: 'Select a starting salary to see jobs matching that range.',
    isMultiSelect: false,
    searchQueryKey: 'salaryrange', // to match searchQuery key due to case sensitivity
  },

  workType: {
    title: 'Are you looking for a full-time role?',
    description: ' Let us know which work types match your search.',
    isMultiSelect: true,
    searchQueryKey: 'worktype', // to match searchQuery key due to case sensitivity
  },
  workArrangement: {
    title: 'What’s your ideal work arrangement?',
    description:
      'Tell us what you want, so we can match the right jobs to you.',
    isMultiSelect: true,
    searchQueryKey: 'workarrangement', // to match searchQuery key due to case sensitivity
  },
};

export const NUDGE_FACET_CONFIG = {
  withKeywordFieldQuery: ['salaryMin', 'workType', 'workArrangement'],
  withoutKeywordFieldQuery: ['distinctTitle', 'workType'],
};

export const FACET_ORDER = [
  'distinctTitle',
  'salaryMin',
  'workType',
  'workArrangement',
];
